import { render, staticRenderFns } from "./productimage2.vue?vue&type=template&id=1bff4000&"
import script from "./productimage2.vue?vue&type=script&lang=js&"
export * from "./productimage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports